<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        التبويبات
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddType @reloadTask="initialData()" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="dialog = false">
            <DeleteType :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddType from "./types/AddType.vue";
import DeleteType from "./types/DeleteType.vue";
export default {
  components: {
    AddType,
    DeleteType,
  },
  data: () => ({
    overlay: false,
    search: "",
    types: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "اسم التبويب", value: "typeName" },
      { text: "الاجراءات", value: "actions" },
    ],
    currencies: [],
    resources: [],
    types: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/generationTypes`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((types) => {
            self.types = types.data;

            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.types.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.typeName.toLowerCase().includes(v));
        });
      } else {
        return this.types;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
